import gql from 'graphql-tag';

export const CreateParticipantRestrictivePracticeLabel = gql`
  mutation CreateParticipantRestrictivePracticeLabel(
    $organizationId: ID!
    $participantId: ID!
    $restrictivePracticeId: ID!
    $labelId: ID!
  ) {
    createParticipantRestrictivePracticeLabel(
      organizationId: $organizationId
      participantId: $participantId
      restrictivePracticeId: $restrictivePracticeId
      labelId: $labelId
    ) {
      id
    }
  }
`;
